<template>
    <div class="container flex flex-direction">
        <dv-loading v-if="loading" class="loading">Loading...</dv-loading>
        <div class="page-title self-center">
            双暖孝亲活力守护平台
            <el-link class="link link1" :href="`/digitize/building${xiangmu_id ? `?xiangmu_id=${xiangmu_id}` : ''}`" :underline="false" v-if="!isShouHu">队伍</el-link>
            <el-link class="link link2" :href="`/digitize/team_development${xiangmu_id ? `?xiangmu_id=${xiangmu_id}` : ''}`" :underline="false" v-if="!isShouHu">队员</el-link>
            <el-link class="link link3" :href="`/digitize/service_rank${xiangmu_id ? `?xiangmu_id=${xiangmu_id}` : ''}`" :underline="false" v-if="!isShouHu">服务</el-link>
            <el-link class="link link4" :href="`/digitize/real_time${xiangmu_id ? `?xiangmu_id=${xiangmu_id}` : ''}`" :underline="false" v-if="!isShouHu">评价</el-link>
        </div>

        <div class="flex align-center justify-between padding-top-lg">
            <div class="content-item">
                <div class="all-num flex-sub flex align-center justify-around">
                    <img class="icon" src="../../../assets/img/data/icon_team_blue.png">
                    <div class="flex flex-direction align-center ">
                        <div class="label max margin-bottom-xs">成立队伍数量</div>
                        <div class="flex align-end">
                            <dv-digital-flop :config="{style:style,number:[team_num],content:'{nt}'}"
                                             class="number"/>
                            <div class="label margin-left-xs">个</div>
                        </div>

                    </div>
                    <div class="flex flex-direction align-center ">
                        <div class="label max margin-bottom-xs">覆盖社区数量</div>
                        <div class="flex align-end">
                            <dv-digital-flop :config="{style:style,number:[shequ_num],content:'{nt}'}"
                                             class="number"/>
                            <div class="label margin-left-xs">个</div>
                        </div>

                    </div>
                </div>

                <div :color="['#fa9d1b','yellow']" backgroundColor="transparent" class="title-container">
                    <div class="bg-title">
                        <div class="title">队伍排名</div>
                    </div>
                    <div class="blue flex flex-direction padding" style="height: 800px;padding-top: 50px;">
                        <el-table
                            class="solid margin-top-xs"
                            v-loading="loading"
                            :data="service_team"
                            height="386"
                            header-row-class-name="table-header"
                            style="width: 100%">

                            <el-table-column label="服务队名称" prop="level" width="260">
                                <template slot-scope="scope">
                                    <div class="table-item">
                                        {{ scope.row.name }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="队员人数" prop="level">
                                <template slot-scope="scope">
                                    <div class="table-item">
                                        <div class="total">{{ scope.row.member_num }}名</div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="服务次数" prop="level">
                                <template slot-scope="scope">
                                    <div class="table-item">
                                        <div class="total">{{ scope.row.service_num }}次</div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>

            </div>
            <div class="content-item">
                <div class="all-num flex-sub flex align-center justify-around">
                    <img class="icon" src="../../../assets/img/data/icon_pople_blue.png">
                    <div class="flex flex-direction align-center ">
                        <div class="label max margin-bottom-xs">物业队员数量</div>
                        <!--            wuye_num-->
                        <div class="flex align-end">
                            <dv-digital-flop :config="{style:style,number:[wuye_num],content:'{nt}'}"
                                             class="number"/>
                            <div class="label margin-left-xs">名</div>
                        </div>

                    </div>
                    <div class="flex flex-direction align-center ">
                        <div class="label max margin-bottom-xs">居民队员数量</div>
                        <!--            jm_num-->
                        <div class="flex align-end">
                            <dv-digital-flop :config="{style:style,number:[jm_num],content:'{nt}'}"
                                             class="number"/>
                            <div class="label margin-left-xs">名</div>
                        </div>

                    </div>
                </div>
                <div :color="['#fa9d1b','yellow']" backgroundColor="transparent"
                                  class="title-container margin-bottom-sm">
                    <div class="bg-title">
                        <div class="title">队员构成</div>
                    </div>
                    <div class="red  padding" style="position:relative;height: 390px;padding-top: 50px;">
                        <div id="member_echarts" class="echarts"></div>
                        <div class="legend">
                            <div v-for="(item,index) in goucheng_arr " :key="index"
                                 class="flex align-center justify-between margin-bottom">
                                <span v-if="index === 0" style="background: #f35945"></span>
                                <span v-if="index === 1" style="background: #16c8d3"></span>
                                <span v-if="index === 2" style="background: #dcca36"></span>
                                <span v-if="index === 3" style="background: #1886ff"></span>
                                <i>{{ item.name }}</i>
                                <b>{{ (goucheng ? item.num / goucheng * 100 : 0).toFixed(2) }} <u>%</u> </b>
                            </div>

                        </div>
                    </div>
                </div>
                <div :color="['#fa9d1b','yellow']" backgroundColor="transparent" class="title-container">
                    <div class="bg-title">
                        <div class="title">队长风采</div>
                    </div>
                    <div class="red flex flex-direction padding" style="height: 390px;padding-top: 50px;">
                        <div class="padding-sm flex align-center">
                            <div class="swiper-button-prev swiper-button-prev1"></div>
                            <swiper
                                ref="swiper"
                                style="width: 525px;"
                                navigation
                                :pagination="{ clickable: true }"
                                :options="swiperOption">
                                <swiper-slide v-for="(item,index) in duizhang_list" :key="index">
                                    <div class="member-item flex flex-direction align-center">
                                        <img v-if="item.avatar" class="image" :src="upUrl + item.avatar"/>
                                        <img v-else class="image" src="../../../assets/img/sn-logo.png"/>
                                        <div class="name margin-tb-xs">{{ item.name }}</div>
                                        <div class="info ovHide padding-lr-xs">{{ item.team_name }}</div>
                                        <div class="info ovHide padding-lr-xs">{{ item.xiaoqu_name }}</div>
                                    </div>
                                </swiper-slide>
                            </swiper>

                            <div class="swiper-button-next swiper-button-next1"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-item">
                <div class="all-num flex-sub flex align-center justify-around">
                    <img class="icon" src="../../../assets/img/data/icon_server_blue.png">
                    <div class="flex flex-direction align-center ">
                        <div class="label max margin-bottom-xs">受益老人数量</div>
                        <div class="flex align-end">
                            <dv-digital-flop :config="{style:style,number:[shouyi_jumin_num],content:'{nt}'}"
                                             class="number"/>
                            <div class="label margin-left-xs">名</div>
                        </div>

                    </div>
                    <div class="flex flex-direction align-center ">
                        <div class="label max margin-bottom-xs">志愿服务次数</div>
                        <div class="flex align-end">
                            <dv-digital-flop :config="{style:style,number:[service_num],content:'{nt}'}"
                                             class="number"/>
                            <div class="label margin-left-xs">次</div>
                        </div>

                    </div>
                </div>
                <div :color="['#fa9d1b','yellow']" backgroundColor="transparent"
                                  class="title-container margin-bottom-sm">
                    <div class="bg-title">
                        <div class="title">服务需求</div>
                    </div>
                    <div class="blue flex flex-direction padding" style="height: 390px;padding-top: 50px;">

                        <div class="xuqiu-item flex align-center justify-between">
                            <span>服务类型</span>
                            <span></span>
                            <span>服务次数</span>
                        </div>
                       <div class="flex flex-direction " style="height: 300px;overflow-y: auto">
                           <div class="xuqiu-item flex align-center justify-between" v-for="(item,index) in service_list" :key="index">
                               <span><i style=" background-color: #e99122;">{{ index + 1  }}</i>{{ item.name }}</span>
                               <el-progress class="flex-sub" :show-text="false" :stroke-width="20"
                                            :percentage="item.num / totle_num *100" color="#e99122"></el-progress>
                               <span>{{ item.num }} 次</span>
                           </div>
                       </div>
<!--                        <div class="xuqiu-item flex align-center justify-between">-->
<!--                            <span><i style=" background-color: #1ec254;">2</i>扫</span>-->
<!--                            <el-progress class="flex-sub" :show-text="false" :stroke-width="20"-->
<!--                                         :percentage="sao_lv" color="#1ec254"></el-progress>-->
<!--                            <span>{{ sao_num }} 次</span>-->
<!--                        </div>-->
<!--                        <div class="xuqiu-item flex align-center justify-between">-->
<!--                            <span><i style=" background-color: #16c8d3;">3</i>换</span>-->
<!--                            <el-progress class="flex-sub" :show-text="false" :stroke-width="20"-->
<!--                                         :percentage="huan_lv" color="#16c8d3"></el-progress>-->
<!--                            <span>{{ huan_num }}次</span>-->
<!--                        </div>-->

                    </div>
                </div>
                <div :color="['#fa9d1b','yellow']" backgroundColor="transparent" class="title-container">
                    <div class="bg-title">
                        <div class="title">服务展示</div>
                    </div>
                    <div class="red flex flex-direction padding" style="height: 390px;padding-top: 70px;">
                        <div class="padding-sm flex align-center server-zs">
                            <div class="swiper-button-prev swiper-button-prev2" @click="setSlide(1)"></div>

                            <el-carousel :interval="4000" type="card"
                                         :indicator-position="'none'"
                                         ref="carousels"
                                         style="width: 600px">
                                <el-carousel-item v-for="(item,index) in zhanshi_images" :key="index">
                                    <el-image
                                        style="width: 250px; height: 250px"
                                        :fit="'cover'"
                                        :src="item"
                                        :preview-src-list="zhanshi_images"></el-image>
                                </el-carousel-item>
                            </el-carousel>

                            <div class="swiper-button-next swiper-button-next2" @click="setSlide(2)"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import {serviceTotalData} from "@/api/weilao";
import {upFeil} from "@/config";
import * as echarts from "echarts";

export default {
    name: "building",
    data() {
        return {
            xiangmu_id: '',
            isShouHu: false,
            loading: false,
            style: {
                width: '150px',
                fontSize: 30,
                fill: '#ffd800',
                fontFamily: 'PingFang SC',
                fontWeight: 'bold'
            },
            swiperOption: {
                // direction: 'vertical',
                slidesPerView: 3,
                loop: true,
                spaceBetween: 20,
                navigation: {
                    nextEl: '.swiper-button-next1',
                    prevEl: '.swiper-button-prev1'
                },
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                }
            },
            swiperOption2: {
                watchSlidesProgress: true,
                slidesPerView: 'auto',
                centeredSlides: true,
                loop: true,
                loopedSlides: 3,
                navigation: {
                    nextEl: '.swiper-button-next2',
                    prevEl: '.swiper-button-prev2'
                },

            },
            upUrl: upFeil + '/',

            team_num: 0,
            shequ_num: 0,
            wuye_num: 0,
            jm_num: 0,
            shouyi_jumin_num: 0,
            service_num: 0,

            service_team: [],
            duizhang_list: [],
            zhanshi_images: [],

            service_list:[],
            ban_num: 0,
            sao_num: 0,
            huan_num: 0,
            ban_lv: 0,
            sao_lv: 0,
            huan_lv: 0,
            totle_num: 0,
            goucheng: 0,
            goucheng_arr: [],
            member_option: {
                animationDuration: 2000,
                animationEasing: 'cubicOut',
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                grid: {
                    show: false,
                },
                color: ['#f35945', '#16c8d3', '#dcca36', '#1886ff'],
                legend: {
                    show: false,

                    type: 'scroll',
                    orient: 'vertical',

                    itemWidth: 30,
                    itemHeight: 10,
                    itemGap: 30,
                    right: '60px',
                    top: '80px',
                    textStyle: {
                        fontSize: 16,
                        color: '#fff'
                    },
                    data: [
                        '楼门长',
                        '物业职工',
                        '居民',
                        '社会组织'
                    ]
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: {show: false},
                        dataView: {show: false, readOnly: false},
                        restore: {show: false},
                        saveAsImage: {show: false}
                    }
                },
                series: [
                    {
                        name: '人数占比',
                        type: 'pie',
                        radius: [60, 120],
                        center: ['35%', '50%'],
                        roseType: 'radius',
                        itemStyle: {
                            borderRadius: 5
                        },
                        label: {
                            show: false
                        },
                        emphasis: {
                            label: {
                                show: true
                            }
                        },
                        data: [
                            {value: 0, name: '楼门长 '},
                            {value: 0, name: '物业职工 '},
                            {value: 0, name: '居民 '},
                            {value: 0, name: '社会组织 '},

                        ]
                    }
                ]
            }


        }
    },
    components: {Swiper, SwiperSlide},
    mounted() {
        this.isShouHu = this.$route.query.xiangmu_id ? Number( this.$route.query.xiangmu_id) === 0 : false
        this.xiangmu_id = this.$route.query.xiangmu_id != 0 ? this.$route.query.xiangmu_id : ''
        this.init()
    },
    methods: {
        setSlide(num) {
            if (num === 1) this.$refs.carousels.prev()
            if (num === 2) this.$refs.carousels.next()
        },
        async init() {
            this.loading = true
            let member_echarts = echarts.init(document.getElementById('member_echarts'))
            const res = await serviceTotalData(this.xiangmu_id)
            this.loading = false
            this.team_num = res.data.team_num
            this.shequ_num = res.data.shequ_num
            this.wuye_num = res.data.wuye_num
            this.jm_num = res.data.jm_num
            this.shouyi_jumin_num = res.data.shouyi_jumin_num
            this.service_num = res.data.service_num
            this.service_team = res.data.service_team
            this.duizhang_list = res.data.duizhang
            this.service_list = res.data.service_list_num
            res.data.zhanshi_images.map(item => {
                this.zhanshi_images.push(this.upUrl + item)
            })
            this.ban_num = res.data.ban_num
            this.ban_lv = res.data.ban_num / res.data.totle_num * 100
            this.sao_num = res.data.sao_num
            this.sao_lv = res.data.sao_num / res.data.totle_num * 100
            this.huan_num = res.data.huan_num
            this.huan_lv = res.data.huan_num / res.data.totle_num * 100
            this.totle_num = res.data.totle_num
            this.goucheng_arr = res.data.goucheng_arr

            let _legend = [], _data = []
            res.data.goucheng_arr.map(item => {
                _legend.push(item.name)
                item.value = item.num
                _data.push(item)
                this.goucheng += item.num
            })
            this.member_option.legend.data = _legend
            this.member_option.series[0].data = _data
            member_echarts.setOption(this.member_option)

        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    background: url(../../../assets/img/data/bg_all_blue.jpg) no-repeat top;
    background-size: 100% 100%;
    height: 1080px;
    width: 1920px;
    overflow: hidden;
    padding: 0 35px 30px;

    .loading {
        color: #ffffff;
        position: fixed;
    }

    .page-title {
        font-size: 36px;
        line-height: 36px;
        color: transparent;
        -webkit-background-clip: text;
        background-image: linear-gradient(0deg,
            #b8efff 0%,
            #ddf7ff 50%,
            #ffffff 100%);
        background-blend-mode: normal, normal;
        margin-top: 25px;
        font-weight: bold;

        .link {
            position: absolute;
            width: 150px;
            font-size: 20px;
            color: #fff;

            &.link1 {
                top: 43px;
                left: 270px
            }

            &.link2 {
                top: 43px;
                left: 445px
            }

            &.link3 {
                top: 43px;
                left: 1340px
            }

            &.link4 {
                top: 43px;
                left: 1520px
            }
        }
    }

    .content-item {
        width: 600px;

        .all-num {
            width: 600px;
            height: 121px;
            padding: 0 40px;
            margin-bottom: 25px;
            background: url(../../../assets/img/data/item-bg_blue.png) no-repeat top;
            background-size: 100% 100%;

            .label {
                font-size: 16px;
                color: #ffffff;

                &.max {
                    font-size: 18px;
                }
            }

            .icon {
                width: 63px;
                height: 63px;
            }

            .number {
                width: 120px;
                height: 36px;
            }
        }

        .title-container {
            box-shadow: inset 0px 0px 30px 0px
            #19caff;
            //border: solid 1px #19caff;
            position: relative;
            clip-path: polygon(16px 0%, calc(100% - 16px) 0%, 100% 16px, 100% calc(100% - 16px), calc(100% - 16px) 100%, 16px 100%, 0% calc(100% - 16px), 0% 16px);
            .border-box-content {
                position: relative;
            }

            .years {
                position: absolute;
                right: 20px;
                top: 50px;
                width: 96px;
                height: 26px;
                line-height: 26px;
                border-radius: 15px;
                border: solid 1px #ffffff;
                text-align: center;
                color: #FFFFFF;
            }

            .bg-title {
                z-index: 99;
                width: 556px;
                text-align: center;
                height: 44px;
                line-height: 44px;
                position: absolute;
                background: url(../../../assets/img/data/bg_title_blue.png) no-repeat top;
                background-size: 100% auto;
                left: 50%;
                transform: translateX(-50%);

            }

            .title {
                line-height: 44px;
                font-size: 24px;
                text-align: center;
                color: transparent;
                -webkit-background-clip: text;
                background-image: linear-gradient(0deg,
                    #ffffff 0%,
                    #ffffff 50%,
                    #ffffff 100%);
                background-blend-mode: normal, normal;
                font-weight: bold;
            }

            .table-item {
                .total {
                    min-width: 100px;
                    height: 28px;
                    line-height: 26px;
                    border-radius: 6px;
                    border: solid 1px #8dd8ee;
                    font-size: 16px;
                    letter-spacing: 1px;
                    color: #ffd700;
                    margin: 0 auto;
                }
            }
        }
    }

    .member-item {
        width: 161px;
        height: 265px;
        background-color: #173979;
        box-shadow: 0px 9px 24px 0px rgba(0, 11, 45, 0.3);

        .image {
            width: 100%;
            height: 168px;
        }

        .name {
            font-size: 16px;
            color: #19caff;
        }

        .info {
            font-size: 14px;
            color: #ffffff;
            width: 100%;
            text-align: center;
        }
    }

    .xuqiu-item {
        height: 60px;
        padding: 18px 26px;
        background-color: #002662;
        margin-bottom: 20px;

        //&:first-child {
        //    background: transparent;
        //    margin-bottom: 0;
        //}

        span {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 16px;
            width: 80px;
            text-align: center;

            i {
                display: block;
                width: 24px;
                height: 24px;
                text-align: center;
                line-height: 24px;
                margin-right: 10px;

                border-radius: 12px;
            }
        }
    }


    .legend {
        position: absolute;
        top: 55%;
        right: 30px;
        transform: translate(0, -50%);

        span {
            display: block;
            width: 30px;
            height: 6px;
            border-radius: 3px;
            margin-right: 10px;
        }

        i {
            width: 80px;
            color: #fff;
            font-size: 16px;
        }

        b {
            width: 80px;
            font-size: 18px;
            color: #ffd700;

            u {
                color: #fff;
                text-decoration: none;
            }
        }
    }

    .dv-border-box-10 {
        background: #b73d0f;
        box-shadow: #fa9d1b55 0px 0px 0px 1px inset !important;
    }

    .swiper-button-prev:after, .swiper-button-next:after {
        color: #fff;
        font-size: 16px;
        width: 13px;
        height: 29px;
        line-height: 29px;
        text-align: center;
        background-color: #19caff;
    }

    .echarts {
        width: 540px;
        height: 290px;
        background: transparent;
    }


}
</style>
